import { render, staticRenderFns } from "./CampaignSender.vue?vue&type=template&id=42a582d0&scoped=true&"
import script from "./CampaignSender.vue?vue&type=script&lang=js&"
export * from "./CampaignSender.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSender.vue?vue&type=style&index=0&id=42a582d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a582d0",
  null
  
)

export default component.exports